export const FrameResource = {
  "ExpressionTitle": "Advanced Expression",
  "ExpressionSave": "Save",
  "ExpressionCancel": "Cancel",
  "CheckFront": "Check",
  "ResetFront": "Reset",
  "AiAssistant": "Assistant",
  "HelpFront": "Tips",
  "ImportFront": "Import",
  "Advanced": "Advanced",
  "String": "String",
  "Estimate": "Estimate",
  "DateTime": "DateTime",
  "Translate": "Translate",
  "Analytical": "Entity",
  "Math": "Math",
  "Extend": "Extend",
  "FunctionSemanticName": "Semantic Name",
  "FunctionName": "Name",
  "FunctionParameter": "Parameter",
  "Variable": "Variable",
  "VariableSessionValue": "Session",
  "VariableContextParameter": "Context",
  "VariableName": "Name",
  "VariableSemanticNameValue": "Semantic Name",
  "Entity": "Data Model",
  "EntityAllColumn": "Code/Name",
  "EntityCode": "Code",
  "EntityName": "Name",
  "EntityType": "Type",
  "EntityPropList": "PropertyList",
  "Help": "Help",
  "HelpCode": "Code",
  "HelpName": "Name",
  "HelpDesc": "Please Choose",
  "HelpDescription": "Select",
  "SaveButton": "Save",
  "CancelButton": "Cancel",
  "FunctionDescription": "Function Description：",
  "VarDescription": "Var Description：",
  "CurrentProp": "Current Property：",
  "CurrentChosedProp": "Currently Selected Property：",
  "PopverTitleDesc": "Description",
  "HelpButtonDesc": {
    $implicit: {
      'syntax': 'Syntax Support',
      'desc': 'Supports JavaScript syntax, does not support "and, or, in, not in" etc, use && not "and", || not "or"',
      'buttonDesc': 'Button',
      'checkButtonDesc': 'Check: Syntax verification',
      'resetButtonDesc': 'Reset: Clear the edit box',
      'functionDesc': 'Function',
      'clickFunctionDesc': 'Click: Display function description, parameters, return types and examples',
      'dbclickFunctionDesc': 'Double-click: Insert the function into the edit box',
      'entityDesc': 'Data',
      'insertByStructureDesc': 'By Struct: Insert the chain structure like "saleOrder.code" into the edit box',
      'insertByPropertyDesc': 'By Attr: Insert the "code" attribute into the edit box',
      'otherDesc': 'Others',
      'areaChangeDesc': 'Area scaling: Function area and Data area can be changed in size',
      'chainedStrucDesc': 'Chain structure: The structure separated by "saleOrder.code" is a chain structure'
    }
  },
  "InsertType": "Insert",
  "InsertByStruct": "Struct",
  "InsertByAttr": "Attr",
  "GetEnum": "GetEnum",
  "EnumJudge": "EnumJudge",
  "NewDataTypeString": "String",
  "NewDataTypeByte": "Byte",
  "NewDataTypeBoolean": "Boolean",
  "NewDataTypeDate": "Date",
  "NewDataTypeDateTime": "DateTime",
  "NewDataTypeDecimal": "Decimal",
  "NewDataTypeInteger": "Integer",
  "NewDataTypeEnum": "Enum",
  "EntityType_Main": "MainTable",
  "EntityType_ChildTable": "ChildTable",
  "EntityType_Other": "Entity",
  "EntitySet": "ChildTable",
  "EntityEnum": "Enum",
  "EntityEnum_Int": "Integer",
  "EntityEnum_String": "String"
}